export function Brand({ light = false, className = "", showText = true, size = "md" }) {
  const h = size === "lg" ? "h-12" : size === "sm" ? "h-8" : "h-10";
  const txt = size === "lg" ? "text-2xl" : "text-lg";
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <img
        src="/logo.png"
        alt="Chahal Overseas Immigration"
        className={`${h} w-auto object-contain shrink-0`}
        draggable={false}
      />
      {showText && (
        <div className="leading-none">
          <div className={`font-head font-extrabold tracking-tight ${txt} ${light ? "text-white" : "text-slate-900"}`}>
            Chahal <span className="text-primary">Overseas</span>
          </div>
          <div className={`text-[10px] font-semibold uppercase tracking-[0.18em] ${light ? "text-slate-300" : "text-slate-400"}`}>
            Immigration
          </div>
        </div>
      )}
    </div>
  );
}
